module.exports = __webpack_public_path__ + "img/Goto_Line_16px_Icon-red.985a4525.svg";